document.addEventListener('DOMContentLoaded', function() {
  // 1) UTM untuk semua link produk
  document.querySelectorAll('a[href*="/products/"]').forEach(function(link) {
    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      url.searchParams.set('utm_source', 'blog');
      url.searchParams.set('utm_medium', 'blog');
      link.setAttribute('href', url.pathname + url.search);
    } catch(e) {
      console.warn('UTM script: invalid URL', link);
    }
  });

  // 2) (Opsional) Unwrap link ke thefloraladvisor.com
  document.querySelectorAll('a[href*="thefloraladvisor.com"]').forEach(function(link) {
    var txt = link.textContent;
    link.parentNode.replaceChild(
      document.createTextNode(txt),
      link
    );
  });

  // 3) Ganti semua teks "FloralAdvisor" → "FlowerAdvisor"
  ;(function walk(node) {
    node.childNodes.forEach(function(child) {
      if (child.nodeType === Node.TEXT_NODE) {
        child.textContent = child.textContent.replace(/FloralAdvisor/g, 'FlowerAdvisor');
      } else {
        walk(child);
      }
    });
  })( document.querySelector('article') || document.body );
});
